export default __webpack_public_path__ + "static/media/cloud-icon.d9839ac9.svg";